module.exports = __webpack_public_path__ + "img/1514039353.1f688449.jpg";